import React, { useMemo } from 'react';
import { GenericFormPage } from '../../components/generic';
import { useUser, User } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';
import { useLocation } from 'react-router-dom';

const Form: React.FC = () => {
  const location = useLocation();
  const isEditMode = location.pathname.includes('/edit');
  
  // Update the password field - required for create, optional for edit
  const configWithPasswordHandling = useMemo(() => {
    const fields = moduleConfig.fields.map((field) => {
      if (field.name === 'userPassword') {
        return {
          ...field,
          required: !isEditMode, // Required only for create, optional for edit
          placeholder: isEditMode ? 'Leave blank to keep current password' : 'Enter password',
          validation: isEditMode ? {
            ...field.validation,
            required: false, // Make optional in edit mode
          } : field.validation,
        };
      }
      return field;
    });

    // Custom create/update handlers that handle password correctly
    const customCreate = async (data: Partial<User & { userPassword?: string }>) => {
      return await moduleConfig.form.create(data);
    };

    const customUpdate = async (id: number, data: Partial<User & { userPassword?: string }>) => {
      // Remove password if it's empty (don't update password if not provided)
      const updateData = { ...data };
      if (updateData.userPassword === '' || updateData.userPassword === undefined || updateData.userPassword === null) {
        delete updateData.userPassword;
      }
      return await moduleConfig.form.update(id, updateData);
    };

    return {
      ...moduleConfig,
      fields,
      getInitialFormData,
      mapItemToFormData,
      form: {
        ...moduleConfig.form,
        create: customCreate,
        update: customUpdate,
      },
    };
  }, [isEditMode]);

  return (
    <GenericFormPage<User & { userPassword?: string }>
      useData={useUser}
      config={configWithPasswordHandling}
    />
  );
};

export default Form;

